// Backup
/*
redProducts = Products which is sold out.
yellowProducts = Products which is in cart but not sold out.
*/

const apiEndpoints = {
  globalProductLimit: 'https://api.schallergallery.org/index.php/api/product-count',
  addingProduct: 'https://api.schallergallery.org/index.php/api/checkProductInCart',
  productCartPageLoad: 'https://api.schallergallery.org/index.php/api/productCartPageLoad',
  updateProductOrdered: 'https://api.schallergallery.org/index.php/api/updateProductOrdered',
  deletedUserSocket: 'ws://35.86.199.189:41234.php',
  reservationProductList: 'https://api.schallergallery.org/index.php/api/reservation-product-list',
  updateSessionUserId: 'https://api.schallergallery.org/index.php/api/update-session-user-id',
  deleteProduct: 'https://api.schallergallery.org/index.php/api/delete-product'
};

const apiKey = '9NVw9WDP?QK%jDG';

let userId,
  soldProducts = [],
  myCartList = [],
  yellowProducts = [],
  redProducts = [],
  globalProductLimit = 0;

const apiHeader = {
  "Content-Type": "application/json",
  "api_key": apiKey
};

// ===== Progress Bar Setup =====
function getProgressBars() {
  return $('div.progress-bar__progress');
}

const STATUS_CLASSES =
  'progress-bar__progress_green progress-bar__progress_yellow progress-bar__progress_red progress-bar__progress_lost';

const green = ['progress-bar__progress_green', 'Cart Reservation - Active'];
const yellow = ['progress-bar__progress_yellow', 'Cart Reservation - Active'];
const red = ['progress-bar__progress_red', 'Cart Reservation - Running Out'];
const lost = ['progress-bar__progress_lost', 'Cart Reservation - Lost'];

// ===== Persistent Timer Keys =====
const TIMER_KEYS = {
  endAt: 'ct_timer_end_at',             // epoch ms
  startedAt: 'ct_timer_started_at',     // epoch ms
  latestStamp: 'ct_timer_latest_stamp'  // string timestamp from API
};

const TOTAL_MINUTES = 15;
const TOTAL_MS = TOTAL_MINUTES * 60 * 1000;

// Global timer state
window.cartTimer = window.cartTimer || {
  rafId: 0,
  intervalId: 0
};

/**
 * Show/hide the progress bar container.
 */
function setProgressBarVisible(isVisible) {
  const el = document.querySelector('.progress-bar-container');
  if (!el) return;
  el.style.display = isVisible ? '' : 'none';
}

function setProgressBarStatus(dataArr) {
  const $progressBars = getProgressBars();
  if (!$progressBars.length) return;

  $progressBars.removeClass(STATUS_CLASSES).addClass(dataArr[0]);

  const headingSpan = document.querySelector('.progress-bar-container .progress-bar__heading span');
  if (headingSpan) {
    headingSpan.style.color = "#fff";
    headingSpan.textContent = dataArr[1];
  }
}

/**
 * Compute minutes elapsed (0..15) based on startedAt/endAt.
 */
function getElapsedMinutesFromStorage() {
  const startedAt = Number(localStorage.getItem(TIMER_KEYS.startedAt) || 0);
  const endAt = Number(localStorage.getItem(TIMER_KEYS.endAt) || 0);
  if (!startedAt || !endAt) return null;

  const now = Date.now();
  const elapsedMs = Math.max(0, now - startedAt);
  return Math.floor(elapsedMs / 60000);
}

/**
 * Apply correct status color based on elapsed minutes.
 */
function applyStatusFromElapsedMinutes(elapsedMinutes) {
  if (elapsedMinutes < 7) {
    setProgressBarStatus(green);
  } else if (elapsedMinutes < 13) {
    setProgressBarStatus(yellow);
  } else if (elapsedMinutes < 15) {
    setProgressBarStatus(red);
  } else {
    setProgressBarStatus(lost);
  }
}

/**
 * Render bar width based on remaining time.
 */
function renderProgress() {
  const endAt = Number(localStorage.getItem(TIMER_KEYS.endAt) || 0);
  const startedAt = Number(localStorage.getItem(TIMER_KEYS.startedAt) || 0);

  const $progressBars = getProgressBars();
  if (!endAt || !startedAt || !$progressBars.length) return;

  const now = Date.now();
  const remaining = Math.max(0, endAt - now);
  const percent = (remaining / TOTAL_MS) * 100;

  $progressBars.css('width', `${percent.toFixed(2)}%`);

  const elapsedMinutes = Math.floor(Math.max(0, now - startedAt) / 60000);
  applyStatusFromElapsedMinutes(elapsedMinutes);

  if (remaining <= 0) {
    setProgressBarStatus(lost);
    $progressBars.css('width', '0%');

    setTimeout(() => {
      clearCartTimeout();
    }, 500);

    setTimeout(() => {
      window.location.reload();
    }, 10000);

    stopProgressLoops();
    return;
  }

  window.cartTimer.rafId = requestAnimationFrame(renderProgress);
}

function stopProgressLoops() {
  if (window.cartTimer.rafId) cancelAnimationFrame(window.cartTimer.rafId);
  window.cartTimer.rafId = 0;

  if (window.cartTimer.intervalId) clearInterval(window.cartTimer.intervalId);
  window.cartTimer.intervalId = 0;
}

/**
 * Start/resume the progress loop from stored endAt.
 */
function resumeTimerIfPresent() {
  const endAt = Number(localStorage.getItem(TIMER_KEYS.endAt) || 0);
  const startedAt = Number(localStorage.getItem(TIMER_KEYS.startedAt) || 0);

  if (!endAt || !startedAt) return;

  const $progressBars = getProgressBars();
  if (!$progressBars.length) return;

  if (Date.now() >= endAt) {
    setProgressBarStatus(lost);
    $progressBars.css('width', '0%');
    return;
  }

  stopProgressLoops();
  renderProgress();

  window.cartTimer.intervalId = setInterval(() => {
    const elapsedMinutes = getElapsedMinutesFromStorage();
    if (elapsedMinutes == null) return;
    applyStatusFromElapsedMinutes(elapsedMinutes);
  }, 60000);
}

/**
 * Create or refresh a timer based on a server timestamp (created_date from API).
 */
function startOrResumeTimerFromLatestTimestamp(latest_timestamp) {
  if (!latest_timestamp) return;

  const latestTime = new Date(latest_timestamp.replace(' ', 'T') + 'Z');
  const latestMs = latestTime.getTime();
  if (!Number.isFinite(latestMs)) return;

  const prevLatest = localStorage.getItem(TIMER_KEYS.latestStamp);
  const hasTimer = Boolean(localStorage.getItem(TIMER_KEYS.endAt));
  const latestChanged = prevLatest !== latest_timestamp;

  if (!hasTimer || latestChanged) {
    const startedAt = latestMs;
    const endAt = latestMs + TOTAL_MS;

    localStorage.setItem(TIMER_KEYS.startedAt, String(startedAt));
    localStorage.setItem(TIMER_KEYS.endAt, String(endAt));
    localStorage.setItem(TIMER_KEYS.latestStamp, latest_timestamp);
  }

  setProgressBarVisible(true);
  resumeTimerIfPresent();
}

/**
 * If Shopify cart has items, ensure the progress bar is visible and timer exists/runs.
 * If Shopify cart is empty, hide it and clear timer keys.
 */
async function syncProgressBarWithShopifyCart() {
  try {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) return;

    const cart = await r.json();
    const hasItems = Number(cart.item_count || 0) > 0;

    if (!hasItems) {
      setProgressBarVisible(false);
      stopProgressLoops();
      localStorage.removeItem(TIMER_KEYS.endAt);
      localStorage.removeItem(TIMER_KEYS.startedAt);
      localStorage.removeItem(TIMER_KEYS.latestStamp);
      return;
    }

    // Cart has items
    setProgressBarVisible(true);

    // If no timer yet, start one now so the bar renders immediately.
    const hasTimer = Boolean(localStorage.getItem(TIMER_KEYS.endAt)) && Boolean(localStorage.getItem(TIMER_KEYS.startedAt));
    if (!hasTimer) {
      const now = Date.now();
      localStorage.setItem(TIMER_KEYS.startedAt, String(now));
      localStorage.setItem(TIMER_KEYS.endAt, String(now + TOTAL_MS));
      localStorage.setItem(TIMER_KEYS.latestStamp, 'shopify_add_' + now);
    }

    resumeTimerIfPresent();
  } catch (e) {
    // silent
  }
}

/**
 * Intercept Shopify add-to-cart calls so the bar shows immediately without refresh.
 */
function installCartInterceptors() {
  // ---- fetch interceptor ----
  if (window.__ctFetchWrapped) return;
  window.__ctFetchWrapped = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async function (...args) {
    const res = await originalFetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) ? args[0].url : '';
      const isAdd =
        url.includes('/cart/add') ||
        url.includes('/cart/add.js') ||
        url.includes('cart/add');

      if (isAdd && res && res.ok) {
        // FIX: Increased delay to 1500ms to give Shopify time to commit the
        // cart before we check its state, preventing a race condition where
        // the cart appears empty and triggers clearCartTimeout().
        setTimeout(() => {
          syncProgressBarWithShopifyCart();
        }, 1500);
      }
    } catch (e) {
      // ignore
    }

    return res;
  };

  // ---- XHR interceptor (covers jQuery AJAX themes) ----
  if (!window.__ctXhrWrapped) {
    window.__ctXhrWrapped = true;

    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__ctUrl = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...sendArgs) {
      this.addEventListener('load', () => {
        try {
          const url = this.__ctUrl || '';
          const isAdd =
            (typeof url === 'string') &&
            (url.includes('/cart/add') || url.includes('/cart/add.js') || url.includes('cart/add'));

          if (isAdd && this.status >= 200 && this.status < 300) {
            // FIX: Same 1500ms delay applied to XHR interceptor for consistency.
            setTimeout(() => {
              syncProgressBarWithShopifyCart();
            }, 1500);
          }
        } catch (e) {
          // ignore
        }
      });

      return origSend.apply(this, sendArgs);
    };
  }
}

// =====================
// Cart + API Logic (your existing functions, minimally touched)
// =====================

async function updateUserId(account_id) {
  const userIDs = {
    "user_session_id": userId,
    "user_id": account_id
  };
  try {
    const response = await fetch(`${apiEndpoints.updateSessionUserId}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(userIDs)
    });
    await response.json();
    userId = account_id;
  } catch (error) {
    console.error('Something went wrong - ' + error);
  }
}

function uniqueUserId(account_id) {
  userId = localStorage.getItem("ct-cart-id");

  if (userId) {
    if (account_id !== undefined && account_id !== '' && userId !== account_id) {
      updateUserId(account_id);
      localStorage.setItem("ct-cart-id", account_id);
    }
  } else {
    if (account_id !== undefined && account_id !== '') {
      userId = account_id;
    } else {
      userId = 'CT' + (Math.random() + 1).toString(36).substring(3);
    }
    localStorage.setItem("ct-cart-id", userId);
  }
}

async function setGlobalProductLimit() {
  const userID = { "user_id": userId };
  try {
    const response = await fetch(`${apiEndpoints.globalProductLimit}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(userID)
    });
    const data = await response.json();
    globalProductLimit = data.product_count;
    localStorage.setItem('globalProductLimit', globalProductLimit);

    if (window.location.href.indexOf("cart") > -1) {
      $('div.cartHeader__group p span')[0].innerHTML = data.product_count;
    }
  } catch (error) {
    $(".product-add-btn-cart").attr("disabled", false);
    console.error('Something went wrong - ' + error);
  }
}

function refreshMyCart(data) {
  if (data && data.product_id && Array.isArray(data.product_id) && data.product_id.length > 0) {
    setProgressBarVisible(true);

    const productsID = data.product_id;
    myCartList = [];

    const last = productsID[productsID.length - 1];
    const latest_timestamp = last?.created_date;

    if (latest_timestamp) {
      startOrResumeTimerFromLatestTimestamp(latest_timestamp);
    }

    for (let i = 0; i < productsID.length; i++) {
      const product_id_ele = productsID[i];
      if (!myCartList.includes(product_id_ele.product_id)) {
        myCartList.push(product_id_ele.product_id);
      }
    }
  } else {
    setProgressBarVisible(false);

    stopProgressLoops();
    localStorage.removeItem(TIMER_KEYS.endAt);
    localStorage.removeItem(TIMER_KEYS.startedAt);
    localStorage.removeItem(TIMER_KEYS.latestStamp);

    // FIX: Only clear the Shopify cart if we actually had items reserved before.
    // Prevents clearCartTimeout() from firing on a cold empty page load, which
    // was causing /cart/clear.js to be called immediately after adding an item.
    if (myCartList.length > 0) {
      clearCartTimeout();
    }
  }
}

function cartRefreshYellowRedCart(data, update_status_btn) {
  let yellowProductsID = data.product_id;
  yellowProducts = [];

  if (yellowProductsID && Array.isArray(yellowProductsID)) {
    for (let i = 0; i < yellowProductsID.length; i++) {
      const product_id_ele = yellowProductsID[i];
      if (!yellowProducts.includes(product_id_ele.product_id)) {
        yellowProducts.push(product_id_ele.product_id);
      }
    }
  }

  let redPoductsID = data.product_ordered_id;
  redProducts = [];
  if (redPoductsID && Array.isArray(redPoductsID)) {
    for (let i = 0; i < redPoductsID.length; i++) {
      const product_id_ele = redPoductsID[i];
      if (!redProducts.includes(product_id_ele)) {
        redProducts.push(product_id_ele);
      }
    }
  }

  if (update_status_btn === 'true') {
    cartButtonsController();
  }
}

function cartButtonsController() {
  const $container = $('.product-buy-container').first();
  if (!$container.length) return;

  const $add_to_cartBtn = $container.find('button.product-add-btn-cart').first();
  const $btnText = $add_to_cartBtn.find('.product-add-btn-text').first();
  const $productStatusIndicator = $container.find('span.product-status__timer').first();

  if (!$add_to_cartBtn.length || !$btnText.length || !$productStatusIndicator.length) return;

  const buttonTextDefault = 'Add to cart';
  const buttonTextGreen = 'Item reserved and added to cart';
  const buttonTextYellow = 'Sorry, item is currently reserved';
  const buttonTextRed = 'Sold';
  const buttonTextLimit = 'Limit reached';

  const productStatusGreen = ['Item is in your cart.', 'product-status__timer product-status__timer-yellow'];
  const productStatusYellow = ['Reserved', 'product-status__timer product-status__timer-yellow'];
  const productStatusRed = ['Item has been sold', 'product-status__timer product-status__timer-red'];
  const productStatusLimit = ['You exceeded the 6 item limit', 'product-status__timer product-status__timer-red'];

  const isSoldOutByLiquid =
    $add_to_cartBtn.hasClass('sold-out') ||
    $add_to_cartBtn.is(':disabled') ||
    ($container.find('input[name="product_is_soldout"]').val() === 'true');

  if (isSoldOutByLiquid) {
    $productStatusIndicator.removeClass().addClass(productStatusRed[1]).html(productStatusRed[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextRed);
    return;
  }

  const $currentProduct = $container.find('button[data-pid]').first();
  if (!$currentProduct.length) return;

  const item_id = String($currentProduct.attr('data-pid') || '');

  $add_to_cartBtn.attr('disabled', true);

  const inCart = myCartList.includes(item_id);
  const isReserved = yellowProducts.includes(item_id);
  const isSoldByLists = soldProducts.includes(item_id);

  if (isSoldByLists) {
    $productStatusIndicator.removeClass().addClass(productStatusRed[1]).html(productStatusRed[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextRed);
    return;
  }

  if (!inCart && !isReserved) {
    const globalProductLimitVar = Number(localStorage.getItem('globalProductLimit') || 0);

    if (globalProductLimitVar < 6) {
      $productStatusIndicator.html('');
      $add_to_cartBtn.removeAttr('disabled');
      $btnText.text(buttonTextDefault);
    } else {
      $productStatusIndicator.removeClass().addClass(productStatusLimit[1]).html(productStatusLimit[0]);
      $add_to_cartBtn.attr('disabled', true);
      $btnText.text(buttonTextLimit);
    }
    return;
  }

  if (inCart) {
    $productStatusIndicator.removeClass().addClass(productStatusGreen[1]).html(productStatusGreen[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextGreen);
    return;
  }

  if (isReserved) {
    $productStatusIndicator.removeClass().addClass(productStatusYellow[1]).html(productStatusYellow[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextYellow);
    return;
  }
}

async function cartFetchAllProductStatus(update_status_btn = 'false', call_back_function) {
  try {
    const userID = { "user_session_id": userId };

    let myCart, red_yellowCart;

    if ($(".variant-addbtn-container").length > 0) {
      var productID = $("input[name='product_id']").val();
      productID = parseInt(productID);

      if (userId == "" || userId == undefined || userId == null) {
        userId = "abc123xyz";
      }

      const productArr = {
        "user_id": userId,
        "product_id": productID
      };

      [myCart, red_yellowCart] = await Promise.all([
        fetch(apiEndpoints.productCartPageLoad, {
          method: "POST",
          headers: apiHeader,
          body: JSON.stringify(userID)
        }),
        fetch('https://api.schallergallery.org/index.php/api/check-product-in-others-cart', {
          method: "POST",
          headers: apiHeader,
          body: JSON.stringify(productArr)
        })
      ]);
    } else {
      [myCart, red_yellowCart] = await Promise.all([
        fetch(apiEndpoints.productCartPageLoad, {
          method: "POST",
          headers: apiHeader,
          body: JSON.stringify(userID)
        }),
        fetch(apiEndpoints.productCartPageLoad, {
          method: "POST",
          headers: apiHeader
        })
      ]);
    }

    if (myCart.ok && red_yellowCart.ok) {
      const myCart_data = await myCart.json();
      refreshMyCart(myCart_data);

      const red_yellowCart__data = await red_yellowCart.json();
      cartRefreshYellowRedCart(red_yellowCart__data, update_status_btn);
    } else {
      cartButtonsController();
    }

    if (typeof call_back_function === 'function') call_back_function();

  } catch (error) {
    console.error('Error occurred during API call:' + error);
  }
}

async function cartAddToCart(cart_product_id, cart_product_handle, is_sold_out) {
  if (is_sold_out != 'true') {
    const add_productQuery = {
      "product_id": cart_product_id,
      "product_handler": cart_product_handle,
      "user_session_id": userId
    };

    try {
      const response = await fetch(`${apiEndpoints.addingProduct}`, {
        method: 'POST',
        headers: apiHeader,
        body: JSON.stringify(add_productQuery)
      });

      const apiResponse = await response.json();
      const status = JSON.stringify(apiResponse.status);

      if (status === 'true' && !myCartList.includes(cart_product_id)) {
        myCartList.push(cart_product_id);
        ++globalProductLimit;
        localStorage.setItem("globalProductLimit", globalProductLimit);

        const now = Date.now();
        localStorage.setItem(TIMER_KEYS.startedAt, String(now));
        localStorage.setItem(TIMER_KEYS.endAt, String(now + TOTAL_MS));
        localStorage.setItem(TIMER_KEYS.latestStamp, 'manual_add_' + now);

        setProgressBarVisible(true);
        resumeTimerIfPresent();
      }

      cartButtonsController();
      return status;
    } catch (error) {
      console.error('Error occurred during API call:' + error);
    }
  }
}

async function cartDeleteProduct(cartDelete_product_id) {
  const delete_ProductQuery = {
    "product_id": cartDelete_product_id,
    "user_id": userId
  };

  try {
    const response = await fetch(`${apiEndpoints.deleteProduct}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(delete_ProductQuery)
    });

    if (!response.ok) throw new Error("Failed to delete product");

    const deletedStatus = await response.json();

    if (deletedStatus.status == true) {
      myCartList = myCartList.filter(id => String(id) !== String(cartDelete_product_id));

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          $(".title-wrapper-with-link .cartHeader__group p span").text(cart.item_count);

          if (cart.item_count === 0) {
            setProgressBarVisible(false);

            stopProgressLoops();
            localStorage.removeItem(TIMER_KEYS.endAt);
            localStorage.removeItem(TIMER_KEYS.startedAt);
            localStorage.removeItem(TIMER_KEYS.latestStamp);
          } else {
            setProgressBarVisible(true);
            resumeTimerIfPresent();
          }
        })
        .catch(error => console.error("Failed to fetch cart:", error));

      let globalProductLimitVar = Number(localStorage.getItem('globalProductLimit') || 0) - 1;
      localStorage.setItem('globalProductLimit', Math.max(0, globalProductLimitVar));
    }

    return deletedStatus;
  } catch (error) {
    console.error('Something went wrong - ' + error);
  }
}

async function clearCartTimeout() {
  try {
    const request = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    if (request.ok) {
      $('#cart-icon-bubble .cart-count-bubble span').html('');
      localStorage.setItem('globalProductLimit', 0);

      setProgressBarVisible(false);

      stopProgressLoops();
      localStorage.removeItem(TIMER_KEYS.endAt);
      localStorage.removeItem(TIMER_KEYS.startedAt);
      localStorage.removeItem(TIMER_KEYS.latestStamp);
    }

  } catch (error) {
    console.log('Time out cart clear error - ', error);
  }
}

// =====================
// Boot
// =====================
document.addEventListener('DOMContentLoaded', function () {
  // Install interceptors so the bar shows immediately after any cart add
  installCartInterceptors();

  // Sync on initial load
  syncProgressBarWithShopifyCart();

  // Resume timer if present
  resumeTimerIfPresent();
});